import { jsxs as j, Fragment as N, jsx as e } from "react/jsx-runtime";
import { memo as V, useCallback as f } from "react";
import { S as D } from "../../SortSelectorSelect-DdwXZK8T.js";
import { isEmpty as k, SortableContainerContext as z, SortableOverlay as E, getIndexFromID as L, SortableItem as R, getIdFromIndex as u } from "@biron-data/react-components";
import { u as q } from "../../styled-components.browser.esm-BFmoFexH.js";
import { z as y } from "../../utils-wNl4DVdv.js";
import { useSelectorLayout as A } from "../../layout/useSelectorLayout.js";
const T = { label: "Date" }, U = V(function({
  value: l,
  onChange: s,
  placeholder: S,
  handleDelete: $,
  handleChange: o,
  groupedOptions: m
}) {
  const i = A(), d = f(
    (r, c, t) => {
      const a = r;
      a[c].isDefault = !1, a[t].isDefault = !1, s == null || s(r);
    },
    [s]
  ), n = f((r) => {
    if (r === void 0)
      return;
    const c = l ?? [], t = y(m, Number(r));
    s == null || s([
      ...c.map((a) => ({ ...a, isDefault: !1 })),
      {
        asc: !1,
        column: (t == null ? void 0 : t.value) ?? 0,
        isDefault: !1,
        value: t == null ? void 0 : t.label,
        id: t == null ? void 0 : t.id
      }
    ]);
  }, [l, m, s]), w = f((r, c) => {
    const t = y(m, Number(r));
    o(c, {
      asc: !1,
      column: (t == null ? void 0 : t.value) ?? 0,
      isDefault: !1,
      value: t == null ? void 0 : t.label,
      id: t == null ? void 0 : t.id
    });
  }, [m, o]), F = f((r, c) => {
    k(c) && $(r);
  }, [$]), M = f((r, c) => {
    l && o(c, {
      ...l[c],
      asc: r
    });
  }, [o, l]);
  return /* @__PURE__ */ j(N, { children: [
    l && /* @__PURE__ */ e(
      z,
      {
        value: l,
        handleChange: d,
        overlayRender: (r) => /* @__PURE__ */ e(E, { activeId: r, children: /* @__PURE__ */ e(D, { id: r, groupedOptions: m, value: l == null ? void 0 : l[L(r)], allowClear: !0, placeholder: S, layout: i }) }),
        children: l == null ? void 0 : l.map((r, c) => /* @__PURE__ */ e(R, { id: u(c), children: /* @__PURE__ */ e(D, { id: u(c), groupedOptions: m, value: r, allowClear: !0, placeholder: S, onChange: (t) => F(c, t), onSelect: (t) => w(t, c), onDirectionChange: (t) => M(t, c), isDefault: r.isDefault, layout: i }, `${r.column}-${c}`) }, `${r.column}-${c}`))
      }
    ),
    /* @__PURE__ */ e(B, { $iscompact: i === "compact", children: /* @__PURE__ */ e(D, { groupedOptions: m, placeholder: S, id: (l == null ? void 0 : l.length) ?? 0, value: void 0, onChange: n, handleChange: o, layout: i }) })
  ] });
}), B = q.div`
    ${(b) => b.$iscompact ? "" : `
    width: ${100 - 100 / 24 - 3}%;
    margin-left: ${100 / 24}%;
    `}
`;
export {
  T as dateOption,
  U as default
};
//# sourceMappingURL=MultipleSortSelector.js.map
